type Props = {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
  disabled?: boolean;
};

const PAGE_SIZES = [25, 50, 100, 200];

export default function Pagination({
  page,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
  disabled,
}: Props) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(page, totalPages - 1);
  const from = total === 0 ? 0 : safePage * pageSize + 1;
  const to = Math.min((safePage + 1) * pageSize, total);

  const canPrev = !disabled && safePage > 0;
  const canNext = !disabled && safePage < totalPages - 1;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "1rem",
        padding: "0.75rem 1rem",
        background: "white",
        borderRadius: "0.6rem",
        boxShadow: "0 1px 3px rgba(0,0,0,.04)",
        marginTop: "1rem",
        fontSize: "0.85rem",
        flexWrap: "wrap",
      }}
    >
      <div style={{ color: "#73879C" }}>
        {total > 0 ? `${from}–${to} de ${total}` : "Sin resultados"}
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
        <NavButton onClick={() => onPageChange(0)} disabled={!canPrev}>
          «
        </NavButton>
        <NavButton
          onClick={() => onPageChange(safePage - 1)}
          disabled={!canPrev}
        >
          ‹
        </NavButton>

        <span style={{ color: "#1f2933", padding: "0 0.5rem" }}>
          Página{" "}
          <strong>{safePage + 1}</strong> de <strong>{totalPages}</strong>
        </span>

        <NavButton
          onClick={() => onPageChange(safePage + 1)}
          disabled={!canNext}
        >
          ›
        </NavButton>
        <NavButton
          onClick={() => onPageChange(totalPages - 1)}
          disabled={!canNext}
        >
          »
        </NavButton>
      </div>

      <label
        style={{
          color: "#73879C",
          display: "inline-flex",
          alignItems: "center",
          gap: "0.4rem",
        }}
      >
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          disabled={disabled}
        >
          {PAGE_SIZES.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
        por página
      </label>
    </div>
  );
}

function NavButton({
  onClick,
  disabled,
  children,
}: {
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      style={{
        width: "2rem",
        height: "2rem",
        padding: 0,
        borderRadius: "0.4rem",
        background: disabled ? "#f8f9fb" : "white",
        color: disabled ? "#adb5bd" : "#1f2933",
        border: "1px solid #dee2e6",
        cursor: disabled ? "not-allowed" : "pointer",
        fontSize: "0.95rem",
        lineHeight: 1,
      }}
    >
      {children}
    </button>
  );
}
